import { LibraryElementEnum } from 'client/enums/LibraryElementEnum'
import { CommonLibraryElementsCreator } from 'src/editor/shared/entities/common-library-elements-creator'
import { BorderStyleEnum, BorderTypeEnum } from 'common/types/styleTypes'

// NOTE: This class is for non-website pages
export class PageLibraryElementsCreator extends CommonLibraryElementsCreator {
  public [LibraryElementEnum.LibraryForm](
    ...args: Parameters<
      (typeof CommonLibraryElementsCreator.prototype)[LibraryElementEnum.LibraryForm]
    >
  ) {
    const form = super[LibraryElementEnum.LibraryForm](...args)
    form.fieldsCommonStyles = {
      border: {
        color: 'rgb(222, 222, 222)',
        radius: 12,
        type: BorderTypeEnum.fullBorder,
        style: BorderStyleEnum.solid,
        width: 1,
      },
      padding: {
        paddingTop: 16,
        paddingRight: 16,
        paddingBottom: 16,
        paddingLeft: 16,
      },
      backgroundColor: 'rgb(247, 247, 247)',
      color: 'rgb(48, 48, 48)',
    }
    form.buttonCommonStyles = {
      alignSelf: 'center',
      width: '100%',
      border: {
        color: '',
        radius: 12,
        style: BorderStyleEnum.none,
      },
      background: 'rgb(48, 48, 48)',
      textColor: 'rgb(255, 255, 255)',
      padding: {
        paddingTop: 14,
        paddingBottom: 14,
        paddingRight: 0,
        paddingLeft: 0,
      },
    }

    return form
  }
}
